<template>
  <div  class="flex flex-col">
    <div class="flex flex-row space-x-1">
      <div>¿Desea asociar la etiqueta </div>
      <el-tooltip>
        <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''">{{ valores[0] }}</div>
        <!-- <div class="truncate font-semibold max-w-feedbacktag"> ETIQUETA LARGA LARGA TEST</div> -->
        <div class="truncate font-semibold max-w-feedbacktag"> {{ valores[0] }} </div>
      </el-tooltip>
      
    </div>
    <div class="flex flex-row  space-x-1">
      <div> al organismo </div>
      <el-tooltip>
        <div slot="content" :class="isLower1024 ? 'max-w-[18rem]' : ''">{{ valores[1] }}</div>
        <div class="truncate font-semibold max-w-feedbackorganismo"> {{ valores[1] }} </div>
      </el-tooltip>
      <div>?</div>
    </div>
  </div>
</template>

<script>
// OLD 
// COMPONENTE DEPRECADO
export default {
  name: 'feedback-content-tag-agency',
  props: {
    valores: {
      type: [Array],
      default: null
    },
  },
  computed: {
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  }
}
</script>
